import Box from '@mui/material/Box';

const LogoFull = () => (
  <Box
    component="img"
    src="/simpl-logo.svg"
    alt="Logo"
    sx={{ height: 52, maxHeight: '100%', width: 'auto' }}
  />
);

export default LogoFull;
